export const FONT_WEIGHTS = {
  thin: 100,
  'extra-light': 200,
  light: 300,
  regular: 400,
  medium: 500,
  'semi-bold': 600,
  bold: 700,
  'extra-bold': 800,
  black: 900,
  'extra-black': 950,
}
